export interface StockInventory {
  _id: string;
  companyId: string;
  author: string;
  observations: string;
  status: "pending" | "completed";
  stockItens: Array<StockInventoryItem>;
  createdAt: Date;
  updatedAt: Date;
}

interface StockInventoryItem {
  productId: string;
  quantity: number;
}

export interface StockInventoryReportItem {
  productId: string;
  code: string;
  name: string;
  quantity: number;
  quantityStock: number;
  diference: number;
}

export interface StockCountItem {
  productId: string;
  quantity: number;
}

export const STATUS_LABELS = {
  pending: "Pendente",
  completed: "Concluído",
};
